import React,{useState,useEffect} from 'react'
import { Link, useNavigate } from "react-router-dom";
import { Resolver, SubmitHandler, useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import authQueries from '../../../queries/authQueries';


const validationSchema = yup.object({

    name: yup
      .string('⚠ Enter Duration')
      .required('⚠ Duration is required')
      .min(2,'⚠ Duration must be more than 2 characters '),
  });

  const  AddFlwDuration = () => {

    const [errName, setErrName] = useState('')

    const navigate = useNavigate();

    const { register, handleSubmit, formState:{ errors } } = useForm({

        resolver: yupResolver(validationSchema)
    
      });


    const AddDurationdata = 

    authQueries.useFLDAdd(

        (response) => {

            if(response?.message === "Success"){
                navigate('/listfld')
            }else if(response?.error[0].duration){
                setErrName("⚠ "+response?.error[0].duration)
            }

        }
    );


    const onSubmit = (data) => {

    
        const datavalues = {
            duration: data.name,
            status: "ACTIVE",
    
        };
    
        AddDurationdata.mutateAsync(datavalues);    
    
      }


  return (

    <div>

        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
            <li className="breadcrumb-item"><Link to="/listfld">Followup Durations</Link></li>
            <li className="breadcrumb-item active" aria-current="page">Add Followup Duration</li>
            </ol>
        </nav>

        <div className="add_clients">

                <div className="card">
                    <div className="card-header">
                        Add Followup Duration
                    </div>
                    <div id="travel_history" className="collapse show" data-parent="#accordion">

                        <div className="card-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className='form-group'>
                                            <div id='parent' className='form-group'>
                                                <label htmlFor="">Followup Duration</label>
                                                <input className="form-control"  {...register("name")} type="text" name='name' />
                                                <div className='error-msg'>{errors.name?.message} {errName}</div>
                                            </div>
                                        </div>
                                    </div>        
                                </div>
                                
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <button type='submit' className="btn btn-default btn-save">Submit</button>
                                    </div>
                                </div>
                            </form>                            
                        </div>
                    </div>
                </div>
        </div>

    </div>

  )

}

export default AddFlwDuration